import { render } from "./CarouselControls.vue?vue&type=template&id=a5f0d7f6&scoped=true"
import script from "./CarouselControls.vue?vue&type=script&lang=js"
export * from "./CarouselControls.vue?vue&type=script&lang=js"

import "./CarouselControls.vue?vue&type=style&index=0&id=a5f0d7f6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5f0d7f6"]])

export default __exports__